(function () {
  function initMyyaFinder() {

    const finder = document.getElementById("myyaBreastFormFinder");
    if (!finder) return;

    /*
      MYYA PROSTHESIS FITTING GUIDE

      These mappings follow the Myya fitting chart supplied for
      this tool. Missing combinations are intentionally omitted.
      Never interpolate an unavailable size.
    */

    const chart = {
      "AA": {
        "28":1, "30":2, "32":3, "34":4, "36":5,
        "38":6, "40":7, "42":8, "44":9, "46":10,
        "48":11, "50":12, "52":13
      },

      "A": {
        "28":2, "30":3, "32":4, "34":5, "36":6,
        "38":7, "40":8, "42":9, "44":10, "46":11,
        "48":12, "50":13, "52":14
      },

      "B": {
        "28":3, "30":4, "32":5, "34":6, "36":7,
        "38":8, "40":9, "42":10, "44":11, "46":12,
        "48":13, "50":14
      },

      "C": {
        "28":4, "30":5, "32":6, "34":7, "36":8,
        "38":9, "40":10, "42":11, "44":12, "46":13,
        "48":14
      },

      "D": {
        "30":6, "32":7, "34":8, "36":9, "38":10,
        "40":11, "42":12, "44":13, "46":14
      },

      "DD/E": {
        "38":8, "40":9, "42":10, "44":11,
        "46":12, "48":13, "50":14
      },

      "DDD/F": {
        "34":10, "36":11, "38":12,
        "40":13, "42":14
      }
    };

    const bands =
      ["28","30","32","34","36","38","40","42","44","46","48","50","52"];

    const cups =
      ["AA","A","B","C","D","DD/E","DDD/F"];

    let band = null;
    let cup = null;

    const bandBox = document.getElementById("myyaBandChoices");
    const cupBox = document.getElementById("myyaCupChoices");

    function show(name) {
      finder.querySelectorAll(".myya-screen").forEach(function (screen) {
        screen.classList.remove("active");
      });

      const screen = finder.querySelector('[data-screen="' + name + '"]');

      if (screen) {
        screen.classList.add("active");

        const top =
          finder.getBoundingClientRect().top +
          window.pageYOffset -
          100;

        window.scrollTo({
          top: top,
          behavior: "smooth"
        });
      }
    }

    bands.forEach(function (value) {
      const button = document.createElement("button");

      button.type = "button";
      button.className = "myya-size";
      button.textContent = value;

      button.addEventListener("click", function () {
        band = value;
        buildCups();
        show("cup");
      });

      bandBox.appendChild(button);
    });

    function buildCups() {
      cupBox.innerHTML = "";

      cups.forEach(function (value) {
        if (!chart[value] ||
            !Object.prototype.hasOwnProperty.call(chart[value], band)) {
          return;
        }

        const button = document.createElement("button");

        button.type = "button";
        button.className = "myya-size";
        button.textContent = value;

        button.addEventListener("click", function () {
          cup = value;
          showResult();
        });

        cupBox.appendChild(button);
      });
    }

    function showResult() {
      if (!chart[cup] ||
          !Object.prototype.hasOwnProperty.call(chart[cup], band)) {
        return;
      }

      const size = chart[cup][band];

      document.getElementById("myyaResult").textContent = size;

      document.getElementById("myyaResultCopy").textContent =
        "Based on a " +
        band +
        cup +
        " bra, we recommend starting with a Myya breast form in Size " +
        size +
        ".";

      const cashmere = document.getElementById("myyaCashmere");
      const sienna = document.getElementById("myyaSienna");

      cashmere.textContent =
        "SHOP CASHMERE — SIZE " + size + " →";

      sienna.textContent =
        "SHOP SIENNA — SIZE " + size + " →";

      /*
        Replace these TWO handles with the actual product handles.
        We can add direct variant selection after you give me
        the Size 1–14 variant IDs for each product.
      */

      cashmere.href =
        "/products/breast-form-in-cashmere";

      sienna.href =
        "/products/breast-form-in-sienna";

      show("result");
    }

    finder.querySelectorAll("[data-go]").forEach(function (button) {
      button.addEventListener("click", function () {
        show(button.dataset.go);
      });
    });

    const unilateral = finder.querySelector('[data-action="unilateral"]');
    const bilateral = finder.querySelector('[data-action="bilateral"]');

    if (unilateral) {
      unilateral.addEventListener("click", function () {
        show("band");
      });
    }

    if (bilateral) {
      bilateral.addEventListener("click", function () {
        show("bilateral");
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initMyyaFinder);
  } else {
    initMyyaFinder();
  }
})();